<template>
  <div class="map-view">
    <div class="card">
      <div class="card-header">
        <h6 class="mb-0">
          <font-awesome-icon icon="map-marker-alt" />
          {{ $t("map.title") }}
        </h6>
      </div>
      <div class="card-body">
        <map-component
          mapId="map"
          principalMap="map"
          :incidentsList="savedIncidentsList"
          :workplannedList="savedWorkplannedList"
          v-on:select-department="onSelectDepartment"
        ></map-component>
        <map-component
          mapId="mapIDF"
          principalMap="map"
          :incidentsList="savedIncidentsList"
          :workplannedList="savedWorkplannedList"
          :isIDFMap="isIDFMap"
          :mapHeight="mapHeight"
          :mapWidth="mapWidth"
        ></map-component>
        <button
          v-show="displayButton"
          @click="removeFilter"
          size="sm"
          class="btn btn-outline-primary btn-sm"
        >
          {{ $t("map.remove-filter") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import MapComponent from "../components/MapComponent.vue";

export default {
  name: "MapView",
  props: {
    incidentsList: Array,
    workplannedList: Array,
    isListFiltered: Boolean,
  },
  components: {
    MapComponent,
  },
  data() {
    return {
      savedIncidentsList: [],
      savedWorkplannedList: [],
      isIDFMap: true,
      mapWidth: 160,
      mapHeight: 125,
      displayButton: false,
    };
  },
  methods: {
    onSelectDepartment(dept) {
      this.$emit("selected-department", dept);
    },

    removeFilter() {
      this.$emit("selected-department");
    },
  },
  watch: {
    incidentsList() {
      this.savedIncidentsList = this.incidentsList;
    },
    workplannedList() {
      this.savedWorkplannedList = this.workplannedList;
    },
    isListFiltered(val) {
      this.displayButton = val;
    },
  },
};
</script>

<style>
.map-view {
  margin-bottom: 1rem;
}
#mapIDF {
  position: absolute;
  display: initial;
  border: 1px solid;
  margin-left: 60px;
  border-radius: 5px;
  top: 50px;
}
</style>